import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/** "← Voltar": goes back in history, or to `fallback` when the page was opened directly (new tab, link). */
export function BackButton({ fallback = "/", label = "Voltar", className = "", testid = "back-btn" }) {
  const navigate = useNavigate();
  const go = () => ((window.history.state?.idx ?? 0) > 0 ? navigate(-1) : navigate(fallback));
  return (
    <button type="button" onClick={go} data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground ${className}`}>
      <ArrowLeft size={16} weight="bold" /> {label}
    </button>
  );
}
